import React, { useState } from 'react';

function LoginScreen({ onLogin, loading, error }) {
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(password);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: '#f8f7fc' }}>
      <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 16, boxShadow: '0 8px 32px rgba(124,58,237,0.12)', padding: 40 }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📅</div>
          <h1 style={{ fontSize: 26, fontWeight: 900, color: '#1e1b4b', marginBottom: 8 }}>Espace Équipe</h1>
          <p style={{ color: '#64748b', fontSize: 14 }}>
            Entrez votre mot de passe pour accéder à votre espace
          </p>
        </div>

        {/* Error */}
        {error && (
          <div style={{ marginBottom: 16, padding: '12px 16px', background: 'rgba(239,68,68,0.1)', border: '1px solid #ef4444', borderRadius: 8, color: '#b91c1c', fontSize: 13, fontWeight: 600, textAlign: 'center' }}>
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 8 }}>
              Mot de passe
            </label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Votre mot de passe"
              autoFocus
              required
              style={{ width: '100%', padding: '12px 16px', fontSize: 16, border: '2px solid #e2e8f0', borderRadius: 10, outline: 'none', transition: 'border-color 0.15s' }}
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading || !password.trim()}
            style={{
              width: '100%', padding: '14px 20px', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 800,
              background: loading ? '#a5b4fc' : '#7c3aed', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.15s'
            }}
          >
            {loading ? 'Connexion…' : '→ Accéder à mon espace'}
          </button>
        </form>

        <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e2e8f0', textAlign: 'center', fontSize: 12, color: '#94a3b8' }}>
          Même lien pour toute l'équipe • Mot de passe unique par personne
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;